import React from 'react';
import { Box } from '../Box';
export function ComboBoxHeader(props) {
    const { children } = props;
    return (React.createElement(Box.Restricted, { className: "mollie-ui-combo-box-header" }, children));
}
ComboBoxHeader.displayName = 'ComboBox.Header';
//# sourceMappingURL=ComboBoxHeader.js.map